import * as React from "react";
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import { TopicData } from "../models";
import { Box, Checkbox, Grid, Typography } from "@mui/material";
import { MAX_FIRST_CELL_WIDTH } from "../styles/constants";
import TopicViewDetailsWithActions from "./dialogs/details/topicViewDetailsWithActions";

interface ComponentProps {
    topic: TopicData,
    checked: boolean,
    onCheckRow: (checked: boolean, topicId: string) => void;
}

export const TopicLeadingCell: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [detailsOn, setDetailsOn] = React.useState(false);

    const showTopicDetails = () => setDetailsOn(true);

    const closeTopicDetails = () => setDetailsOn(false);

    const onCheckTopic = (checked: boolean) => props.onCheckRow(checked, props.topic.id);

    return (
        <Grid container
            wrap="nowrap"
            alignItems="center"
            maxWidth={MAX_FIRST_CELL_WIDTH}>

            <Grid item padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={props.checked}
                    onChange={(_, checked) => onCheckTopic(checked)} />
            </Grid>

            <Grid item
                xs
                zeroMinWidth
                maxWidth={MAX_FIRST_CELL_WIDTH / 2}>

                <Box sx={{
                    display: "inline-flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "center"
                }}
                >
                    <Typography
                        className="truncated-text"
                        onClick={() => showTopicDetails()}
                    >
                        {props.topic.name}
                    </Typography>

                    {props.topic.restricted ?
                        <span style={{ justifySelf: "start" }} className="material-icons">lock</span>
                        : null}
                </Box>

            </Grid>

            <TopicViewDetailsWithActions
                onShow={detailsOn}
                topicId={props.topic.id}
                closeDetailsDialog={closeTopicDetails} />
        </Grid>
    );
};

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps
    })
);

export type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(TopicLeadingCell);